import React from 'react'

const SvgGrimacingFaceOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M10 9a1 1 0 11-2 0 1 1 0 012 0zM16 9a1 1 0 11-2 0 1 1 0 012 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 12.5H8a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h8a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zM8 11a2 2 0 00-2 2v2a2 2 0 002 2h8a2 2 0 002-2v-2a2 2 0 00-2-2H8z'
    />
    <path fillRule='evenodd' clipRule='evenodd' d='M17 14.5H7v-1h10v1z' />
  </svg>
)

export default SvgGrimacingFaceOutline
